import { render, staticRenderFns } from "./CouponPagination.vue?vue&type=template&id=3b254a08&"
import script from "./CouponPagination.vue?vue&type=script&lang=ts&"
export * from "./CouponPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports